<template>
  <section>
    <div class="shadow-lg mt-3 xl:p-4 md:p-4 p-2 bg-white overflow-x-auto">
      <section>
        <div class="my-1">
          <div class="flex justify-between items-center">
            <h3 class="text-gray-dark font-bold text-md">Invoice</h3>
            <select
              :value="historyType"
              class="bg-transparent text-xs px-4 py-2 ring-1 ring-gray-400 rounded-lg focus:outline-none"
              @change="handleChangeHistoryType"
            >
              <option value="txnHistory">Sessions</option>
              <option value="tips">Tips</option>
            </select>
            <!-- <div
              v-if="historyType === 'txnHistory'"
              class="ml-4 ring-1 ring-gray-300 rounded-lg"
            >
              <button
                type="button"
                @click="handleChangeTxnHistoryType('sessions')"
                :class="{
                  'bg-green-light rounded-l-lg text-white text-xs':
                    txnHistoryType === 'sessions',
                }"
                class="p-2 focus:outline-none"
              >
                Classes
              </button>
              <button
                type="button"
                @click="handleChangeTxnHistoryType('courses')"
                :class="{
                  'bg-green-light rounded-r-lg text-white':
                    txnHistoryType === 'courses',
                }"
                class="p-2 focus:outline-none text-xs"
              >
                Class Packs
              </button>
            </div> -->
          </div>
          <TableAlt
            :thead="getTableHead"
            class="md:mt-8 mt-10 overflow-x-auto"
          >
            <tbody
              class="bg-white divide-y divide-gray-200 md:text-left text-center"
              v-if="walletTableDataType === 'sessions'"
            >
              <tr
                class="hover:bg-gray-100"
                v-for="(orders, i) in userOrderListData"
                :key="orders.order_id"
              >
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ i + 1 }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ orders.session_title }} {{ orders.course_title }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ dateFormat(orders.created_at) }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  <!-- + orders.service_fee -->
                  {{ orders.total_amount }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  <button
                    class="h-8 px-4 m-2 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
                    @click="downloadUserInvoice(orders.order_id, i)"
                  >
                    Download
                  </button>
                  <button
                    class="h-8 px-4 m-2 text-white transition-colors duration-150 bg-red-700 rounded-lg focus:shadow-outline hover:bg-red-800"
                    :class="{ hidden: cancelClass(orders.created_at) }"
                    @click="onclickCancel(orders.order_id)"
                    v-if="orders.transaction_status == 'succeeded'"
                  >
                    Refund
                  </button>
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ orders.transaction_status }}
                </td>
              </tr>
            </tbody>
            <tbody
              class="bg-white divide-y divide-gray-200 md:text-left text-center"
              v-if="walletTableDataType === 'tips'"
            >
              <tr
                class="hover:bg-gray-100"
                v-for="(t, i) in userTipTransactionListData"
                :key="t.order_id"
              >
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ i + 1 }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ t.trainer_name }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ t.title }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  <!-- + t.service_fee -->
                  {{ t.total_amount }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ dateFormat(t.created_at) }}
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  <button
                    class="h-8 px-4 m-2 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
                    @click="downloadTipTransactionInvoice(t.order_id, i)"
                  >
                    Download
                  </button>
                </td>
                <td
                  class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs capitalize"
                >
                  {{ t.transaction_status }}
                </td>
              </tr>
            </tbody>
          </TableAlt>
          <Pagination
            v-if="walletTableDataType === 'sessions'"
            :currentPage="currentPage"
            :handlePageChange="handlePageChange"
            :totalPages="totalPages"
          />
        </div>
      </section>
    </div>
    <Modal
      v-model="isRefundInitiated"
      :whiteCross="'text-white'"
      title="Refund Confirmation"
      :handleClose="closeRefundModalHandler"
    >
        <div class="flex flex-col py-4">
            <p>Are you sure you want to cancel this Class?</p>
            <div class="flex items-center justify-end w-full pt-6">
              <button 
                @click="closeRefundModalHandler"
                class="h-8 px-2 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"> 
                 Cancel 
              </button>
              <button
                class=" h-8 px-4 m-2 w-28 text-white transition-colors duration-150 bg-red-700 rounded-lg focus:shadow-outline hover:bg-red-800"
                :disabled="refundStatus !== 'Refund'"
                :class="refundStatus !== 'Refund' ? 'cursor-not-allowed opacity-50' : ''"
                @click="initiateRefundHandler(isRefundInitiated)"
              >
                {{ refundStatus }}
              </button>
            </div>
        </div>
    </Modal>
  </section>
</template>

<script>
import { Pagination } from "@/components/t-components";
import { TableAlt } from "@/components/t-components";
import { mapActions, mapGetters } from "vuex";
import Modal from '@/components/t-components/Modal.vue'

export default {
  name: "UserProfile",
  components: {
    TableAlt,
    Pagination,
    Modal
  },
  data() {
    return {
      historyType: "txnHistory",
      txnHistoryType: "sessions",
      walletTableDataType: "sessions",
      walletTableDataToShow: [],
      currentPage: 1,
      totalPages: 1,
      userOrderListData: [],
      userTipTransactionListData: [],
      isRefundInitiated: null,
      refundStatus: 'Refund'
    };
  },
  computed: {
    ...mapGetters(["userOrderList", "userTipTransactionList"]),

    getTableHead() {
      if (this.walletTableDataType === "sessions") {
        return [
          "S.No",
          "Title",
          "Purchase Date",
          "Amount",
          "Invoice",
          "Status",
        ];
      }
      //  else if (this.walletTableDataType === "courses") {
      //   return ["Course", "Slot", "Amount", "Date", "Status"];
      // }
      else if (this.walletTableDataType === "tips") {
        return [
          "S.No",
          "Trainer",
          "Session",
          "Amount",
          "Date",
          "Invoice",
          "Status",
        ];
      } else {
        return ["Credits", "Transaction ID", "Amount", "Date", "Status"];
      }
    },
  },
  methods: {
    ...mapActions([
      "postUserOrderList",
      "getUserInvoice",
      "postUserCancelOrder",
      "postUserTipTransactionList",
      "getUserTipTransactionInvoice",
    ]),

    async downloadUserInvoice(id, label) {
      await this.getUserInvoice({ id: id, label: label });
    },

    async downloadTipTransactionInvoice(id, label) {
      await this.getUserTipTransactionInvoice({ id: id, label: label });
    },

    cancelClass(val) {
      const date = new Date(val);
      const now = new Date();
      const miliseconds = Math.abs(date.getTime() - now.getTime());
      const hours = miliseconds / (60 * 60 * 1000);
      if (hours < 24) {
        return false;
      } else {
        return true;
      }
    },

    async onclickCancel(orderId) {
      // var c = confirm("Are you sure you want to cancel this Class?");
      // if (c) {
      //   await this.postUserCancelOrder(orderId);
      // }
      this.isRefundInitiated = orderId
    },

    async handleChangeHistoryType(event) {
      this.historyType = event.target.value;
      if (event.target.value === "txnHistory") {
        this.txnHistoryType = "sessions";
        this.currentPage = 1
        await this.userSessionListHandler()
        this.walletTableDataType = "sessions";
      } else if (event.target.value === "tips") {
        this.currentPage = 1
        await this.userTipListHandler()
        this.walletTableDataType = "tips";
      } else {
        this.walletTableDataType = "wallet";
      }
    },
    async userTipListHandler () {
      const query = {
        page: this.currentPage,
      };
      await this.postUserTipTransactionList({ query });
      this.userTipTransactionListData =
      (this.userTipTransactionList && this.userTipTransactionList.data) || [];
      this.totalPages =
        this.userTipTransactionList && this.userTipTransactionList.last_page;
    },
    async userSessionListHandler () {
      const query = {
        page: this.currentPage,
      };
      await this.postUserOrderList({ query });
      this.userOrderListData =
        (this.userOrderList && this.userOrderList.data) || [];
      this.totalPages = this.userOrderList && this.userOrderList.last_page;
    },
    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      this.userOrderListData = [];
      await this.postUserOrderList({ query });
      this.userOrderListData = this.userOrderList.data || [];
      // (this.userOrders = []),
      //   this.userOrderList.forEach((orders, index) => {
      //     const obj = {
      //       name: index + 1,
      //       date: this.dateFormat(orders.created_at),
      //       amount: orders.total_amount + +orders.service_fee,
      //       orderId: orders.order_id,
      //       transaction_status: orders.transaction_status,
      //     };
      //     this.userOrders.push(obj);
      //   });
    },
    closeRefundModalHandler () {
      this.isRefundInitiated = null
    },
    async initiateRefundHandler (orderId) {
      this.refundStatus = 'Processing'
      await this.postUserCancelOrder(orderId).then(() => {
        this.refundStatus= 'Refund'
        this.hideRefundHandler(orderId)
        this.isRefundInitiated = null
      }).catch(() => {
        this.refundStatus= 'Refund'
      })
    },
    hideRefundHandler (orderId) {
      this.userOrderListData && this.userOrderListData.length && this.userOrderListData.map((itm) => {
        if (itm.order_id === orderId) {
          itm.transaction_status = 'refunded'
        }
        return itm
      })
    }
  },
  async created() {
    this.userSessionListHandler()
  },
};
</script>